import { Algorithm } from '../../../utils/algorithm';
// Algorithm to pack rectangles
export class Packing extends Algorithm {
    get PackedWidth() {
        return this.packedWidth;
    }
    set PackedWidth(value) {
        this.packedWidth = value;
    }
    get PackedHeight() {
        return this.packedHeight;
    }
    set PackedHeight(value) {
        this.packedHeight = value;
    }
    // Aspect ratio of the bounding box of the packed solution
    get PackedAspectRatio() {
        return this.PackedWidth / this.PackedHeight;
    }
    getRects() {
        const ret = [];
        for (const [r, center] of this.rectsToCenters) {
            r.center = center;
            ret.push(r);
        }
        return ret;
    }
}
//# sourceMappingURL=Packing.js.map